var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { styled, useTheme } from '@creditas-ui/react';
export var PaginationContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: fit-content;\n  min-width: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: ", ";\n  color: ", ";\n\n  button {\n    border: 0;\n    cursor: pointer;\n    background-color: transparent;\n    padding: 8px;\n    display: flex;\n    border-radius: ", ";\n\n    &:hover {\n      background-color: ", ";\n      border-radius: ", ";\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n    }\n  }\n"], ["\n  max-width: fit-content;\n  min-width: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: ", ";\n  color: ", ";\n\n  button {\n    border: 0;\n    cursor: pointer;\n    background-color: transparent;\n    padding: 8px;\n    display: flex;\n    border-radius: ", ";\n\n    &:hover {\n      background-color: ", ";\n      border-radius: ", ";\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacingX['23xl'];
}, function (_a) {
    var theme = _a.theme;
    return theme.spacingX.sm;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[100];
}, function (_a) {
    var theme = _a.theme;
    return theme.radius.round;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[10];
}, function (_a) {
    var theme = _a.theme;
    return theme.radius.round;
});
function ArrowLeft(_a) {
    var _b = _a.color, color = _b === void 0 ? useTheme().colors.neutral[90] : _b;
    return (React.createElement("svg", { fill: "none", width: "12", height: "12", strokeWidth: "1", viewBox: "0 0 6 10" },
        React.createElement("path", { d: "M5 1L1 5L5 9", stroke: color })));
}
function ArrowRight(_a) {
    var _b = _a.color, color = _b === void 0 ? useTheme().colors.neutral[90] : _b;
    return (React.createElement("svg", { fill: "none", width: "12", height: "12", strokeWidth: "1", viewBox: "0 0 6 10" },
        React.createElement("path", { d: "M1 9L5 5L1 1", stroke: color })));
}
export var Icon = {
    ArrowLeft: ArrowLeft,
    ArrowRight: ArrowRight,
};
var templateObject_1;
//# sourceMappingURL=Pagination.style.js.map